const developmentOrigin = ["http://localhost", "5000"].join(":");
const configuredUrl = process.env.REACT_APP_API_URL || developmentOrigin;

export const API_ORIGIN = configuredUrl
  .trim()
  .replace(/\/+$/, "")
  .replace(/\/api$/i, "");

export const API_BASE = `${API_ORIGIN}/api`;

export function buildApiUrl(path = "") {
  const value = String(path || "").trim();
  const normalizedPath = value
    ? value.startsWith("/")
      ? value
      : `/${value}`
    : "";

  return `${API_BASE}${normalizedPath}`;
}

export function buildPublicFileUrl(path = "") {
  if (!path) return "";

  const value = String(path).trim();

  if (/^(?:https?:)?\/\//i.test(value) || value.startsWith("data:")) {
    return value;
  }

  const normalizedPath = value.startsWith("/") ? value : `/${value}`;

  return `${API_ORIGIN}${normalizedPath}`;
}
